import { useQuery } from '@tanstack/react-query'
import { SpendMetrics, getSpendMetrics } from 'api/pulse/spendMetrics'
import { PulseFilters } from 'api/pulse'
import { getSpendMetricsKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useSpendMetrics(query: PulseFilters) {
  return useQuery<SpendMetrics>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getSpendMetricsKey(query),
    queryFn: ({ signal }) => getSpendMetrics(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
